import React from 'react';
import { Icon, IconProps } from '../../icons/Icon';

import './StatCard.css';

export type StatCardIconVariant = 'primary' | 'success' | 'warning' | 'info' | 'neutral';
export type StatCardLayout = 'horizontal' | 'vertical';

export interface StatCardChange {
  /** The change value (e.g., "+12%", "5") */
  value: string | number;
  /** Direction of change */
  direction: 'up' | 'down';
  /** Optional label for the change */
  label?: string;
}

export interface StatCardProps {
  /** Icon name from Lucide icons */
  icon?: IconProps['name'];
  /** Icon color variant */
  iconVariant?: StatCardIconVariant;
  /** Label describing the stat */
  label: string;
  /** The stat value */
  value: string | number;
  /** Optional change indicator */
  change?: StatCardChange;
  /** Optional subtext below the value */
  subtext?: string;
  /** Layout direction */
  layout?: StatCardLayout;
  /** Additional CSS class */
  className?: string;
}

export const StatCard = React.memo(function StatCard({
  icon,
  iconVariant = 'primary',
  label,
  value,
  change,
  subtext,
  layout = 'horizontal',
  className = '',
}: StatCardProps) {
  return (
    <div className={`stat-card ${className}`.trim()} data-layout={layout}>
      {icon && (
        <div className="stat-card__icon" data-variant={iconVariant}>
          <Icon name={icon} size={28} />
        </div>
      )}
      <div className="stat-card__content">
        <p className="stat-card__label">{label}</p>
        <p className="stat-card__value">{value}</p>
        {change && (
          <div className="stat-card__change" data-direction={change.direction}>
            <Icon name={change.direction === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>
              {change.value}
              {change.label && ` ${change.label}`}
            </span>
          </div>
        )}
        {subtext && <p className="stat-card__subtext">{subtext}</p>}
      </div>
    </div>
  );
});
